/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */
//= require './public_indexes_projects_widgets'

window.OpportunityWidgets = {
  tasksHits() {
    return instantsearch.widgets.hits({
      container: '#oppo-tasks-search-result',
      transformItems(items) {
        $('#oppo-tasks-search-result').empty();
        return items;
      },
      templates: {
        item: $('#oppo-task-template').text(),
        empty: $('#no-search-results-found-template').text()
      },
      cssClasses: {
        list: 'list-view items borders oppo-tasks-listing',
        item: 'item'
      }
    });
  },

  opportunitiesHits() {
    return instantsearch.widgets.infiniteHits({
      container: '#oppo-search-result',
      transformItems(items) {
        $('#oppo-search-result').empty();
        items.map(function (item) {
          if (item.tasks_counters.pending >= 0) {
            item.tasks_counters.pending = I18n.t('opportunities.tasks.counters.pending', { count: item.tasks_counters.pending });
          }
          if (item.value >= 0) {
            if (item.value >= 1.0e+12) {
              item.value = (item.value / 1.0e+12).toFixed(1) + 'T';
            } else if (item.value >= 1.0e+9) {
              item.value = (item.value / 1.0e+9).toFixed(1) + 'B';
            } else if (item.value >= 1.0e+6) {
              item.value = (item.value / 1.0e+6).toFixed(1) + 'M';
            } else if (item.value >= 1.0e+3) {
              item.value = (item.value / 1.0e+3).toFixed(1) + 'K';
            } else {
              item.value = item.value;
            }
          }
          item.status = item.status.replace("_", " ");
          return item;
        });
        return items;
      },
      templates: {
        item: $('#oppo-template').text(),
        empty: $('#no-search-results-found-template').text()
      },
      cssClasses: {
        list: 'list-view items borders oppo-tasks-listing ais-Hits-list',
        root: 'ais-Hits',
        item: 'item'
      }
    });
  },

  statusWidget() {
    return instantsearch.widgets.refinementList({
      container: '#status',
      attribute: 'status',
      sortBy: ['isRefined'],
      limit: 5,
      searchable: false,
      cssClasses: {
        searchableSubmit: 'hidden',
        searchableReset: 'hidden'
      },
      templates: {
        item(hit) {
          return "<label class='ais-RefinementList-label'>" +
            "<input type='checkbox' class='ais-RefinementList-checkbox' value='" + hit.value + "' " + (hit.isRefined ? 'checked' : '') + ">" +
            "<span class='status-label label-opportunity-status " + hit.value + "'>" + hit.value.toLowerCase().replace('_', ' ') + "</span>" +
            "</input><span class='ais-RefinementList-count'>" + hit.count + "</span>" +
            "</label>";
        }
      }
    });
  },

  searchBoxWidget() {
    return instantsearch.widgets.searchBox({
      container: '#search-box',
      placeholder: 'Keyword',
      reset: false,
      magnifier: false,
      cssClasses: {
        submit: ['hidden'],
        reset: ['hidden']
      }
    });
  },

  descriptionWidget() {
    return {
      init(options) {
        return $('#description').on('click', function () {
          const attributes = ['title'];
          if ($(this).is(":checked")) { attributes.push('description'); }
          options.helper.setQueryParameter('restrictSearchableAttributes', attributes);
          return options.helper.search();
        });
      }
    };
  },

  dateMenuWidget(fieldName) {
    return instantsearch.widgets.numericMenu({
      container: '#date-menu',
      attribute: fieldName,
      items: [
        { label: 'Today', start: moment().startOf('day').unix(Number), end: moment().endOf('day').unix(Number) },
        { label: 'Tommorow', start: moment().add(1, 'days').startOf('day').unix(Number), end: moment().add(1, 'days').startOf('day').unix(Number) },
        { label: 'Next 7 days', start: moment().startOf('day').add(1, 'second').unix(Number), end: moment().add(7, 'days').startOf('day').unix(Number) },
        { label: 'Next 30 days', start: moment().startOf('day').add(2, 'second').unix(Number), end: moment().add(30, 'days').startOf('day').unix(Number) },
        { label: 'Overdue', start: 0, end: moment().unix(Number) }
      ],
      cssClasses: {
        root: 'ais-RefinementList',
        list: 'ais-RefinementList-list',
        item: 'ais-RefinementList-item'
      },
      templates: {
        item(hit) {
          return "<label class='ais-RefinementList-label'>" +
            "<input type='checkbox' class='ais-RefinementList-checkbox' value='" + hit.value + "' " + (hit.isRefined ? 'checked' : '') + ">" +
            "<span class='ais-RefinementList-labelText'>" + hit.label + "</span>" +
            "</label>";
        }
      }
    });
  },

  typeFilter() {
    return instantsearch.widgets.refinementList({
      container: '#type-filter',
      attribute: 'type',
      sortBy: ['isRefined'],
      limit: 5,
      searchable: true,
      cssClasses: {
        searchableSubmit: 'hidden',
        searchableReset: 'hidden'
      },
      templates: {
        item: PublicIndexesProjectsWidgets._refinementListTemplate
      }
    });
  },

  opportunitiesFilter() {
    return instantsearch.widgets.refinementList({
      container: '#opportunity-filter',
      attribute: 'opportunity.title',
      sortBy: ['isRefined'],
      limit: 5,
      searchable: true,
      cssClasses: {
        searchableSubmit: 'hidden',
        searchableReset: 'hidden'
      },
      templates: {
        item: PublicIndexesProjectsWidgets._refinementListTemplate
      }
    });
  },

  assignedToFilter() {
    return instantsearch.widgets.refinementList({
      container: '#assignee-filter',
      attribute: 'assigned_to.name',
      sortBy: ['isRefined'],
      limit: 5,
      searchable: true,
      cssClasses: {
        searchableSubmit: 'hidden',
        searchableReset: 'hidden'
      },
      templates: {
        item: PublicIndexesProjectsWidgets._refinementListTemplate
      }
    });
  },

  valueWidget() {
    return instantsearch.widgets.rangeSlider({
      container: "#value",
      attribute: 'value',
      precision: 1,
      pips: false,
      tooltips: {
        format(value) {
          if (value >= 1.0e+12) {
            return (Math.round(value / 1.0e+12) + 'T').toLocaleString();
          } else if (value >= 1.0e+9) {
            return (Math.round(value / 1.0e+9) + 'B').toLocaleString();
          } else if (value >= 1.0e+6) {
            return (Math.round(value / 1.0e+6) + 'M').toLocaleString();
          } else if (value >= 1.0e+3) {
            return (Math.round(value / 1.0e+3) + 'K').toLocaleString();
          } else {
            return (value).toLocaleString();
          }
        }
      }
    });
  },

  ownersWidget() {
    return instantsearch.widgets.refinementList({
      container: '#owners',
      attribute: 'owner.name',
      sortBy: ['isRefined'],
      limit: 5,
      searchablePlaceholder: "Search owner",
      searchable: true,
      cssClasses: {
        searchableSubmit: 'hidden',
        searchableReset: 'hidden'
      }
    });
  }
};
